module.exports = __webpack_public_path__ + "static/media/cockroach(10).65c3b73b.PNG";